var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-full flex-container"},[_c('back-nav'),_c('div',{staticClass:"flex-scroll page-container"},[_c('img',{attrs:{"src":require("@/assets/images/addSuccess.png")}}),_c('p',[_vm._v("商品发布成功")]),_c('div',{staticClass:"add-btn",on:{"click":_vm.addCommodity}},[_vm._v("继续添加")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }